/** Unique keys for DTOs from "saas" module */
export enum SaasDtoKeysEnum {
  /** "BRS" module settings common request and response body */
  BRS_SETTINGS_DTO = 'saas/brs-settings.dto',
  /** Common tenant settings common request and response body */
  COMMON_SETTINGS_DTO = 'saas/common-settings.dto',
  /** Global settings APIs response body */
  GLOBAL_SETTINGS_FIND_DTO = 'saas/global-settings-find.dto',
  /** Global settings edit API request body */
  GLOBAL_SETTINGS_FORM_DTO = 'saas/global-settings-form.dto',
  /** "Plan/Fact" module settings APIs response body */
  PLAN_FACT_SETTINGS_FIND_DTO = 'saas/plan-fact-settings-find.dto',
  /** "Plan/Fact" module settings edit API request body */
  PLAN_FACT_SETTINGS_FORM_DTO = 'saas/plan-fact-settings-form.dto',
  /** Tenant API's response body */
  TENANT_FIND_DTO = 'saas/tenant-find.dto',
  /** Tenant list API's response body */
  TENANT_PAGE_FIND_DTO = 'saas/tenant-page-find.dto',
  /** Tenant updating data transferable object request body */
  TENANT_FORM_DTO = 'saas/tenant-form.dto',
  /** Taken subdomain API's response body */
  TAKEN_SUBDOMAIN_FIND_DTO = 'saas/taken-subdomain-find.dto',
  /** Rate plan API's response body */
  RATE_PLAN_FIND_DTO = 'saas/rate-plan-find.dto',
  /** Rate plan history page pagination response body */
  RATE_PLAN_HISTORY_PAGE_DTO = 'saas/rate-plan-history-page.dto',
  /** Rate plan history pagination response body */
  RATE_PLAN_HISTORY_FIND_DTO = 'saas/rate-plan-history-find.dto',
  /** Rate plan create/update form API request body */
  RATE_PLAN_FORM_DTO = 'saas/rate-plan-form.dto',
  /** Simple tenant creation request body */
  TENANT_SIMPLE_FORM_DTO = 'saas/tenant-simple-form.dto',
  /** Simple external tenant request body */
  TENANT_EXTERNAL_SIMPLE_FORM_DTO = 'saas/tenant-external-simple-form.dto',
  /** Tenant statistics API's response body */
  TENANT_STATISTICS_FIND_DTO = 'saas/tenant-statistics-find.dto',
  /** Tenant statistics metric API's response body */
  TENANT_STATISTICS_METRIC_FIND_DTO = 'saas/tenant-statistics-metric-find.dto',
  /** Tenant with enabled and disabled modules */
  TENANT_MODULES_FIND_DTO = 'saas/tenant-modules-find.dto',
  /** Slice of tenant history (JSON "page") - response body */
  TENANT_HISTORY_PAGE_DTO = 'saas/tenant-history-page.dto',
  /** Tenant history entry - response body */
  TENANT_HISTORY_FIND_DTO = 'saas/tenant-history-find.dto',
  /** Tenant creation data transferable object */
  TENANT_CREATE_FORM_DTO = 'saas/tenant-create-form.dto',
  /** Tenant search form with pagination support */
  TENANT_QUERY_DTO = 'saas/tenant-query.dto',
  /** Available tenant subdomains API response body */
  TENANT_AVAILABLE_SUBDOMAINS_DTO = 'saas/tenant-available-subdomains.dto',
  /** Tenant create/update request body */
  TENANT_PERSONAL_FORM_DTO = 'saas/tenant-personal-form.dto',
  /** Tenant update request body - extended version for admin tenant */
  TENANT_ADMIN_FORM_DTO = 'saas/tenant-admin-form.dto',
  /** Tenant statistics request params */
  TENANT_STATISTICS_QUERY_DTO = 'saas/tenant-statistics-query.dto',
  /** Required and optional fields settings for HelpDesk tasks */
  HELPDESK_REQUIRED_FIELDS_FIND_DTO = 'saas/helpdesk-required-fields-find.dto',
  /** Required and optional fields settings for HelpDesk tasks */
  HELPDESK_REQUIRED_FIELDS_FORM_DTO = 'saas/helpdesk-required-fields-form.dto',
  /** Personal account transaction APIs response body */
  PERSONAL_ACCOUNT_TRANSACTION_FIND_DTO = 'saas/personal-account-transaction-find.dto',
  /** Slice of personal account transactions */
  PERSONAL_ACCOUNT_TRANSACTION_PAGE_DTO = 'saas/personal-account-transaction-page.dto',
  /** Disable debit welcome request params */
  DISABLE_DEBIT_WELCOME_QUERY_DTO = 'saas/disable-debit-welcome-query.dto',
}
